import React from 'react';

/**
 * AiSummaryInitialState Component
 * Displays the initial ungenerated state (Spec §13):
 * "Your AI summary hasn't been generated yet." with an explicit [Generate Summary] button.
 */
export default function AiSummaryInitialState({ onGenerate, isGenerating, selectedPeriod, selectedProject = 'All' }) {
    const scopeLabel = selectedProject && selectedProject !== 'All' ? ` for "${selectedProject}"` : '';

    return (
        <div className="py-8 px-4 text-center space-y-3 bg-white/60 dark:bg-slate-800/40 rounded-xl border border-dashed border-blue-200 dark:border-blue-900/40 my-2">
            <div className="w-10 h-10 mx-auto rounded-full bg-blue-100/70 dark:bg-blue-900/30 text-[#03488A] dark:text-[#00AAF1] flex items-center justify-center">
                <span className="material-symbols-outlined text-2xl">auto_awesome</span>
            </div>
            <div>
                <h4 className="text-sm font-bold text-slate-800 dark:text-slate-200 font-headline">
                    Your AI summary hasn't been generated yet
                </h4>
                <p className="text-xs text-slate-500 dark:text-slate-400 max-w-md mx-auto mt-1 leading-relaxed">
                    Generate an intelligent, role-aware briefing of meaningful project progress, blockers, revisions, and mentions for {selectedPeriod}{scopeLabel}.
                </p>
            </div>
            <div className="pt-2">
                <button
                    onClick={onGenerate}
                    disabled={isGenerating}
                    className="inline-flex items-center gap-2 h-8 px-3.5 text-xs font-bold leading-none text-white rounded-xl shadow-xs hover:opacity-95 active:scale-95 transition-all cursor-pointer disabled:opacity-50"
                    style={{ background: 'linear-gradient(90deg, #03488A 0%, #00AAF1 100%)' }}
                >
                    <span className={`material-symbols-outlined text-sm ${isGenerating ? 'animate-spin' : ''}`}>
                        {isGenerating ? 'autorenew' : 'auto_awesome'}
                    </span>
                    <span>{isGenerating ? 'Generating Summary...' : 'Generate Summary'}</span>
                </button>
            </div>
        </div>
    );
}
